import React, { Component } from 'react'
import { Nav, SimpleFilter, Arrow } from './../../../components'
import Router from './../../../services/Router'
import {RankingStyle} from './../../../styles'
import { withLoader } from '../../../hoc/withLoader';

class Ranking extends Component {
  constructor(props) {
    super(props)

    this.current = null
  }

  state = {
    nav : [
      // {
      //   value: 'Gift',
      //   url: Router.gifts.path
      // },
      {
        value: 'Quizzes',
        url: Router.hubQuizz.path
      },
      {
        value: 'Ranking',
        url: Router.ranking.exactPath
      },
    ],
    viewButton: false,
  }

  componentWillReceiveProps({data}) {
    // await fetchPage().then((data) => {
    if ( data !== this.props ) {
      const nZone = []
      let i = 0
      Object.keys(data).map((zone, index) => {
        nZone.push({ label: zone, slug: zone})
        i = index
        if ( i === Object.keys(data).length - 1) this.setState({ filters: nZone })
        return nZone
      })
      this.setState({ ranking: data})
      this.current = document.querySelector('.ranking-user-line.current')
      if (this.current)  this.setState({ viewButton: this.current.offsetTop > window.innerHeight })
    }
  }

  handlerClick = () => {
    this.setState({ viewButton: false })
   
    document.documentElement.scrollTop = this.current.offsetTop - window.innerHeight / 2
  }

  render() {
    const { ranking, viewButton } = this.state
    const { isReady } = this.props
    return(
      <div className={`ranking page-inner ${ RankingStyle(isReady) }`}>
        <Nav nav={this.state.nav} />
        <div className="ranking-container">
          <div className="ranking filter-ranking">
            <SimpleFilter filters={this.state.filters} parentPath={Router.ranking.exactPath} />
          </div>
          <div className={`ranking-user transition ${isReady ? 'transition--ready' : ''} `}>
          {
              ranking && ranking[this.props.match.params.filter !== undefined ? this.props.match.params.filter : 'General'].map((item, index) => (
                <div className={`ranking-user-line flex ${item.current ? 'current' : ''}`} key={index} >
                  <div className="ranking-user-pos">{item.ranking}</div>
                  <div className="ranking-user-name"> {item.score ? item.name: '-'} </div>
                  <div className="ranking-user-localisation">{item.score ? item.city: '-'}</div>
                  <div className="ranking-user-score">{item.score ? item.score: '-'} </div>
                </div>
              ))
            }
          </div>
          {
            viewButton && (
              <button className="ranking-position-go btn btn--reset" onClick={this.handlerClick}>
                <span className="label"> View my Position </span>
                <Arrow width={24} height={24} />
              </button>
            )
          }
        </div>
      </div>
    )
  }
}

export default withLoader(Ranking, '/challenge/quiz/ranking')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Ranking.js